import { InputBaseComponentProps } from '@mui/material';
import React, { forwardRef } from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

const NumberFormatCustom = forwardRef(
    (
        props: NumericFormatProps & {
            defaultValue: InputBaseComponentProps['defaultValue'];
        },
        ref,
    ) => {
        return (
            <NumericFormat
                allowedDecimalSeparators={['.', ',']}
                decimalScale={2}
                decimalSeparator=","
                thousandSeparator=" "
                {...props}
                getInputRef={ref}
            />
        );
    },
);

NumberFormatCustom.displayName = 'NumberFormatCustom';

export default NumberFormatCustom;
